import { Attachment, AttachPayload } from 'types/application';
import { attachmentPayloadSetting, attachmentRetrieve, payloadDeleteApplication, formDeleteApplication } from '../helpers';

import { SECT_APPLICANT } from 'common/application.const';
import { ORGANISATION_DETAILS, SECT_ADDRESS } from 'common/application.const/Films/applicantCompany';
import { IMPORT_DETAILS, REMARKS, SUBTITLES_DETAILS, TITLE_DETAILS } from 'common/application.const/Films/Exhibition/SubmissionofNewTitles';
import { MOVIE_TRAILER_DETAILS } from 'common/application.const/Films/Exhibition/SubmissionofTrailersPromotionalMaterials';
import { EPISODE_DETAILS } from 'common/application.const/Films/Distribution/SubmissionofTitlesToObtainAnIndicativeRating';
import { requestAttachmentFVG } from 'store/api/application.api';
import { INFORMATION_ON_FILM } from 'common/application.const/Films/Exhibition/SubmissionOfFilmsWithPartyPoliticalContent';
import { PENDING_KDM } from 'common/application.const/Films/pendingKDM';
import { CA_CLASSIFICATION_DETAILS } from 'common/application.const/Films/RCA/SubmissionOfCoClassifiedFilmsForExhibition';
import { TRAILER_OR_PRODUCT_ADVERTISEMENT_DETAILS } from 'common/application.const/Films/RCA/SubmissionOfCoClassifiedTrailersProductAdvertisementForExhibition';
import { CONTENT_ASSESSOR_REGISTRATION } from 'common/application.const/Films/CA/ContentAssessorRegistration';
import {
    ACADEMIC_QUALIFICATION,
    ADDRESS_OF_EMPLOYER,
    CURRENT_EMPLOYMENT_DETAILS,
    LANGUAGE_PROFICIENCY,
    PERIOD_OF_EMPLOYMENT
} from 'common/application.const/Films/CA/ContentAssessorProfileUpdate';
import { requestAttachmentList, requestInvoiceByType } from 'store/api/application.api';
import { DetailsType, FieldValue, FormData } from 'types/application';
import { formatDateTime } from 'utils/application.helpers';

type Props = {
    myInfoContent: any;
    uen?: string;
    id?: string;
    userRole?: string;
};

const selectFormFilm = (applicationForm: string, applicationType?: string) => {
    // RCA Registration or RCA Renewal
    if (
        applicationForm === 'Content Assessor Registration' ||
        applicationForm === 'FMREG' ||
        applicationForm === 'FMREN' ||
        applicationForm === 'Content Assessor Renewal'
    ) {
        return 'contentAssessorRegistration';
    }

    // RCA Flow
    if (applicationForm === 'Submission Of Co-Classified Films For Exhibition (FMFCA)' || applicationForm === 'FMFCA') {
        return 'submissionOfCoClassifiedFilmsForExhibition';
    }
    if (
        applicationForm === 'Submission Of Co-Classified Trailers/Product Advertisements For Exhibition (FMTCA)' ||
        applicationForm === 'FMTCA'
    ) {
        return 'submissionOfCoClassifiedTrailersProductAdvertisementForExhibition';
    }
    if (applicationForm === 'Submission Of Co-Classified Films for Distribution (FMCA)' || applicationForm === 'FMCA') {
        return 'submissionOfCoClassifiedFilmsForDistribution';
    }

    // Exhibition
    if (
        applicationForm === 'Submission Of New Titles (FMFA)' ||
        applicationForm === 'FMFA' ||
        applicationForm === 'FMNFA' ||
        applicationForm === 'Submission Of New Titles (FMNFA)'
    )
        return 'submissionOfNewTitles';
    if (
        applicationForm === 'Submission Of Trailers/Promotional Materials (FMTA)' ||
        applicationForm === 'FMTA' ||
        applicationForm === 'FMNTA' ||
        applicationForm === 'Submission Of Trailers/Promotional Materials (FMNTA)'
    )
        return 'submissionofTrailers/PromotionaMaterials';
    if (applicationForm === 'Submission Of Repeat Titles With Identical Content (FMFRT)' || applicationForm === 'FMFRT')
        return 'submissionofRepeatTitlesWithIdenticalContent';
    if (applicationForm === 'Submission Of New Titles - Express Service (FMXFA)' || applicationForm === 'FMXFA')
        return 'submissionofNewTitlesForExpressService';
    if (
        applicationForm === 'Submission Of Titles For Re-classification (FMFR)' ||
        applicationForm === 'FMFR' ||
        applicationForm === 'FMNFR' ||
        applicationForm === 'Submission Of Titles For Re-classification (FMNFR)'
    )
        return 'submissionofTitlesForRe-classification';
    if (
        applicationForm === 'Submission Of Films With Party Political Content (FMFP)' ||
        applicationForm === 'FMFP' ||
        applicationForm === 'FMNFP' ||
        applicationForm === 'Submission Of Films With Party Political Content (FMNFP)'
    )
        return 'submissionOfFilmsWithPartyPoliticalContent';

    if (
        applicationForm === 'Submission Of Titles To Obtain An Indicative Rating (FMSA)' ||
        applicationForm === 'FMSA' ||
        applicationForm === 'FMNSA' ||
        applicationForm === 'Submission Of Titles To Obtain An Indicative Rating (FMNSA)'
    ) {
        if (
            applicationType !== 'Film Classification for Distribution' &&
            applicationType !== 'Film Classification for Distribution - Non Profit'
        )
            return 'submissionofTitlesToObtainAnIndicativeRating';
    }

    // Distribution
    if (
        applicationForm === 'Submission Of New Titles (FMA)' ||
        applicationForm === 'FMA' ||
        applicationForm === 'FMNA' ||
        applicationForm === 'Submission Of New Titles (FMNA)'
    )
        return 'submissionOfNewTitlesDistribution';
    if (
        applicationForm === 'Submission Of Repeat Titles With Identical Content (FMRT)' ||
        applicationForm === 'FMRT' ||
        applicationForm === 'Submission Of Repeat Titles With Identical Content (FMRT)'
    )
        return 'submissionofRepeatTitlesWithIdenticalContentDistribution';
    if (
        applicationForm === 'Submission Of Classified Titles With New Extra Features (FMEF)' ||
        applicationForm === 'FMEF' ||
        applicationForm === 'FMNEF' ||
        applicationForm === 'Submission Of Classified Titles With New Extra Features (FMNEF)'
    )
        return 'submissionofClassifiedTitlesWithNewExtraFeaturesDistribution';
    if (applicationForm === 'Submission Of New Titles - Express Service (FMXA)' || applicationForm === 'FMXA')
        return 'submissionofNewTitlesForExpressServiceDistribution';
    if (
        applicationForm === 'Submission Of Titles For Re-classification (FMRA)' ||
        applicationForm === 'FMRA' ||
        applicationForm === 'FMNRA' ||
        applicationForm === 'Submission Of Titles For Re-classification (FMNRA)'
    )
        return 'submissionofTitlesForRe-classificationDistribution';
    if (
        applicationForm === 'Submission Of Films With Party Political Content (FMP)' ||
        applicationForm === 'FMP' ||
        applicationForm === 'FMNP' ||
        applicationForm === 'Submission Of Films With Party Political Content (FMNP)'
    )
        return 'submissionOfFilmsWithPartyPoliticalContentDistribution';
    if (
        applicationForm === 'Submission Of Titles To Obtain An Indicative Rating (FMSA)' ||
        applicationForm === 'FMSA' ||
        applicationForm === 'FMNSA' ||
        applicationForm === 'Submission Of Titles To Obtain An Indicative Rating (FMNSA)'
    )
        if (
            applicationType === 'Film Classification for Distribution' ||
            applicationType === 'Film Classification for Distribution - Non Profit'
        )
            return 'submissionofTitlesToObtainAnIndicativeRatingDistribution';
    return '';
};

export const autoFillData = ({ myInfoContent, uen, id, userRole }: Props) => {
    const general_selected = userRole === 'corppass' ? 'generalCompany' : 'generalApplicant';
    const person = myInfoContent?.corppass || myInfoContent || {};
    const entity = myInfoContent?.['basic-profile'] || {};
    const corpUser = person?.['corppass-user'] || {};
    const address = myInfoContent?.address || person?.regadd || {};
    const isFin = ['F', 'G', 'M'].some((pre: string) => person?.uinfin?.value?.includes(pre));

    let idType;

    if (isFin) idType = 'IDT2';

    if (person?.nationality?.code && !isFin) {
        idType = person.nationality.code === 'SG' ? 'IDT' : '';
    }

    let salutation;
    if (person.sex) {
        salutation = person.sex?.code === 'M' ? 'MR' : 'MS';
    }

    let corpUserID = corpUser['id-type']?.desc;

    if (corpUserID === 'NRIC') corpUserID = 'IDT';
    if (corpUserID === 'FIN') corpUserID = 'IDT2';

    const generalForm = {
        id: general_selected,
        formID: general_selected,
        hasError: true,
        values: {
            [`${SECT_APPLICANT}-id-type`]: corpUserID || idType,
            [`${SECT_APPLICANT}-idno`]: corpUser['id-no']?.value || person?.uinfin?.value,
            [`${SECT_APPLICANT}-salutaion`]: salutation,
            [`${SECT_APPLICANT}-name`]: corpUser.name?.value || person?.name?.value,
            [`${SECT_APPLICANT}-mobile-no-country-code`]: person?.mobileno?.areacode?.value || '65',
            [`${SECT_APPLICANT}-mobile-no-main`]: person?.mobile?.value || person?.mobileno?.nbr?.value,
            [`${SECT_APPLICANT}-email`]: person?.email?.value,
            // [`${SECT_APPLICANT}-nationality`]: person?.nationality?.code,

            [`${ORGANISATION_DETAILS}-organisation-uen-no`]: entity.uen?.value,
            [`${ORGANISATION_DETAILS}-organisation-name`]: entity['entity-name']?.value,

            [`${SECT_ADDRESS}-postal`]: address.postal?.value,
            [`${SECT_ADDRESS}-block-house`]: address.block?.value,
            [`${SECT_ADDRESS}-street`]: address.street?.value,
            [`${SECT_ADDRESS}-floor`]: address.floor?.value,
            [`${SECT_ADDRESS}-unit`]: address.unit?.value,
            [`${SECT_ADDRESS}-building`]: address.building?.value
        }
    };

    return generalForm;
};

function flattenFilmObject(obj: any) {
    const mapping: any = {
        'Romanised Title': 'romanizedTitle',
        Rating: 'rating',
        Type: 'type',
        'Also Known As': 'alsoKnownAs',
        Decision: 'decision',
        'Decision Date': 'decisionDate',
        'Consumer Advice': 'consumerAdvice',
        'Language Group': 'languageGroup',
        Format: 'format',
        'Sub Language': 'subLanguage',
        'Other Language': 'otherLanguage',
        'Other Format': 'otherFormat'
    };

    const flattened = { ...obj };
    delete flattened.filmDetails;

    obj?.filmDetails?.forEach(({ label, value }: { label: string; value?: string }) => {
        const key = mapping[label] || label;
        flattened[key] = value ?? '';
    });

    return flattened;
}

export const formatRetrieve = async (
    _content: any,
    _caseTypeID: string,
    _action?: string,
    applicationForm?: string,
    applicationType?: string,
    userRole?: string,
    dropdownOpts?: any,
    _selectedTitleSearch?: any,
    isActiveDistributionLicenceCompany?: any,
    newApplication?: boolean,
    CAProfileDetails?: any
) => {
    if (_action === 'application-delete') return formDeleteApplication;

    const general_selected = userRole === 'corppass' ? 'generalCompany' : 'generalApplicant';
    const selectedForm = selectFormFilm(applicationForm ?? '', applicationType);
    const applicantValues = _content.applicant || {};
    const companyValues = _content.company || {};
    const applicantContact = applicantValues.ContactPage || {};
    const companyContact = companyValues.ContactPage || {};
    // const applicantAddress =
    //     applicantValues.Address && applicantValues.Address.length > 0 ? applicantValues.Address[0]?.MailingAddress || {} : {};
    const applicantAddress = applicantValues.MailingAddress || {};
    const companyAddress = companyValues.MailingAddress || {};
    const selectedTitleSearch = Array.isArray(_selectedTitleSearch)
        ? _selectedTitleSearch.map((item: any) => flattenFilmObject(item))
        : flattenFilmObject(_selectedTitleSearch?.row);

    let general;
    let applicationFilm;
    let organisation;
    let downloads = {};
    let academicQualification;
    let languageProficiency;
    let employmentDetails;
    let rcaRegistrationDetails;

    const isNewApplication = newApplication && (_content?.FilmTitleList || []);

    const isCA = applicationType === 'Content Assessor (CA) Registration/Renewal';
    const isCAUpdateProfile = applicationForm === 'FMUPD' || applicationForm === 'Content Assessor Profile Update';

    if (_action === 'kdm') {
        applicationFilm = [
            {
                id: 'submissionOfPendingKDM',
                formID: 'submissionOfPendingKDM',
                hasError: true,
                values: {
                    [`${PENDING_KDM}-attachments`]: '',
                    [`${PENDING_KDM}-link-to-attachments`]: '',
                    [`${PENDING_KDM}-remarks`]: ''
                }
            }
        ];

        return [...(applicationFilm || [])];
    }

    if (_action === 'download') {
        const uploadedFiles = (
            _caseTypeID
                ? await requestAttachmentFVG(_caseTypeID).then((res) =>
                      res.map((i: any) => ({
                          ...i,
                          pyCategory:
                              i.Type === 'Application' && i.pyCategory === 'Receipt'
                                  ? 'Payment Receipt'
                                  : i.Type === 'Application' && i.pyCategory === 'Invoice'
                                    ? 'Invoice'
                                    : i.Type === 'Appeal' && i.pyCategory === 'Receipt'
                                      ? 'Appeal Receipt'
                                      : i.Type === 'Appeal' && i.pyCategory === 'Invoice'
                                        ? 'Appeal Invoice'
                                        : i.pyCategory === 'SubmissionReceipt'
                                          ? 'Submission Receipt'
                                          : i.pyCategory === 'Notification'
                                            ? 'Notification'
                                            : i.pyCategory
                      }))
                  )
                : []
        ) as any[];

        let files = {};

        if (_content?.CustomerStatus === 'Rejected' || _content?.CustomerStatus === 'Withdrawn' || _content?.CustomerStatus === 'Voided') {
            files = uploadedFiles
                .filter((i) => i.pyCategory !== 'Certificate' && i.pyCategory !== 'Notification')
                .map((i) => {
                    return {
                        id: 'FVGFiles',
                        data: [i.fileName, i.pyCategory, 'Download'],
                        fileName: i.fileName,
                        pyCategory: i.pyCategory,
                        DownloadLink: i.DownloadLink
                    };
                });
        } else if (
            _content?.CustomerStatus === 'Submitted' ||
            _content?.CustomerStatus === 'Processing' ||
            _content?.CustomerStatus === 'Pending Payment'
        ) {
            files = uploadedFiles
                .filter((i) => i.pyCategory !== 'Certificate' && i.pyCategory !== 'Notification')
                .map((i) => {
                    return {
                        id: 'FVGFiles',
                        data: [i.fileName, i.pyCategory, 'Download'],
                        fileName: i.fileName,
                        pyCategory: i.pyCategory,
                        DownloadLink: i.DownloadLink
                    };
                });
        } else {
            files = uploadedFiles.map((i) => {
                return {
                    id: 'FVGFiles',
                    data: [i.fileName, i.pyCategory, 'Download'],
                    fileName: i.fileName,
                    pyCategory: i.pyCategory,
                    DownloadLink: i.DownloadLink
                };
            });
        }
        downloads = {
            id: 'download',
            formID: 'download',
            hasError: true,
            values: { files }
        };

        return [downloads];
    }

    if (isNewApplication) {
        general = {
            id: general_selected,
            formID: general_selected,
            hasError: true,
            values: {
                [`${SECT_APPLICANT}-application-type`]: _content?.ApplicationType,

                [`${SECT_APPLICANT}-id-type`]: dropdownOpts?.IDTypeFVG?.find((i: any) => i.optLabel === applicantValues.IDType)?.optID,
                [`${SECT_APPLICANT}-idno`]: applicantValues.IDNo,
                [`${SECT_APPLICANT}-salutaion`]: applicantValues.Salutation,
                [`${SECT_APPLICANT}-name`]: applicantValues.Name,
                [`${SECT_APPLICANT}-email`]: applicantContact.EmailAddress,
                [`${SECT_APPLICANT}-email-published-online`]: applicantContact.PublishEmailAddress || CAProfileDetails?.StringVal2,
                [`${SECT_APPLICANT}-other-email`]: applicantContact.OtherEmailAddress || CAProfileDetails?.StringVal1,
                // [`${SECT_APPLICANT}-uen-no`]: applicantValues.CompanyUEN,
                // [`${SECT_APPLICANT}-company`]: applicantValues.CompanyName,
                [`${SECT_APPLICANT}-mobile-no-country-code`]: applicantContact.MobileNoCountryCode || '65',
                [`${SECT_APPLICANT}-mobile-no-main`]: applicantContact.ContactNumber?.slice(3),
                [`${SECT_APPLICANT}-other-mobile-no-country-code`]: applicantContact.OtherPhoneNumberCountryCode || '65',
                [`${SECT_APPLICANT}-other-mobile-no-main`]:
                    applicantContact.OtherContactNumber?.slice(3) || CAProfileDetails?.ContactNumber?.startsWith('+')
                        ? CAProfileDetails?.ContactNumber?.slice(3)
                        : CAProfileDetails?.ContactNumber,
                // [`${SECT_APPLICANT}-nationality`]: applicantValues.Nationality,

                [`${ORGANISATION_DETAILS}-organisation-uen-no`]: companyValues.UEN,
                [`${ORGANISATION_DETAILS}-organisation-name`]: companyValues.CompanyName,
                [`${ORGANISATION_DETAILS}-organisation-mobile-no-country-code`]: companyContact.MobileNoCountryCode || '65',
                [`${ORGANISATION_DETAILS}-organisation-mobile-no-main`]: companyContact.ContactNumber?.slice(3),
                [`${ORGANISATION_DETAILS}-organisation-email`]: companyContact.EmailAddress,
                [`${ORGANISATION_DETAILS}-other-organisation-email`]: companyContact.OtherEmailAddress,

                // [`${SECT_APPLICANT}-office-no-country-code`]: applicantContact.OfficeNoCountryCode || '65',
                // [`${SECT_APPLICANT}-office-no-main`]: applicantContact.OfficeNo,
                // // [`${SECT_APPLICANT}-email`]: applicantContact.EmailAddress ?? 'mark@gmail.com',

                [`${SECT_ADDRESS}-postal`]: applicantAddress.PostalCode || companyAddress.PostalCode,
                [`${SECT_ADDRESS}-block-house`]: applicantAddress.BlockNumber || companyAddress.BlockNumber,
                [`${SECT_ADDRESS}-street`]: applicantAddress.StreetName || companyAddress.StreetName,
                [`${SECT_ADDRESS}-floor`]: applicantAddress.FloorNumber || companyAddress.FloorNumber,
                [`${SECT_ADDRESS}-unit`]: applicantAddress.UnitNumber || companyAddress.UnitNumber,
                [`${SECT_ADDRESS}-building`]: applicantAddress.BuildingName || companyAddress.BuildingName
            }
        };

        const applicationContent = _content?.FilmTitleList || [
            {
                content: {
                    FilmTitleList: {
                        pxObjClass: 'IMDA-FVGCS-Data-FVG-FilmClassification'
                    }
                }
            }
        ];

        const questionList = _content?.QuestionListPage || [];

        applicationFilm = isCA
            ? [
                  {
                      id: `films-1`,
                      formID: selectedForm,
                      hasError: true,
                      values: {
                          [`${CONTENT_ASSESSOR_REGISTRATION}-question-1`]: questionList[0]?.AnswerPage?.Answer || '',
                          [`${CONTENT_ASSESSOR_REGISTRATION}-question-1-remarks`]: questionList[0]?.AnswerPage?.Remarks || '',
                          [`${CONTENT_ASSESSOR_REGISTRATION}-question-2`]: questionList[1]?.AnswerPage?.Answer || '',
                          [`${CONTENT_ASSESSOR_REGISTRATION}-question-2-remarks`]: questionList[1]?.AnswerPage?.Remarks || '',
                          [`${CONTENT_ASSESSOR_REGISTRATION}-question-3`]: questionList[2]?.AnswerPage?.Answer || '',
                          [`${CONTENT_ASSESSOR_REGISTRATION}-question-3-remarks`]: questionList[2]?.AnswerPage?.Remarks || '',
                          [`${CONTENT_ASSESSOR_REGISTRATION}-attachments`]:
                              attachmentRetrieve(_content?.AttachmentPage?.AttachmentList) || '',
                          [`${CONTENT_ASSESSOR_REGISTRATION}-link-to-attachments`]: _content?.AttachmentPage?.LinkToAttachments || ''
                      }
                  }
              ]
            : await Promise.all(
                  applicationContent?.map(async (film: any, index: number) => {
                      const filmTitleDetailsList = film?.FilmTitleDetailsList?.map((item: any, index: number) => {
                          if (film.IsBoxSet === 'Yes') {
                              return {
                                  [`${TITLE_DETAILS}-${index + 1}-language-group`]: item.LanguageGroup || '',
                                  [`${TITLE_DETAILS}-${index + 1}-sub-language-group`]: item.SubLanguage || '',
                                  [`${TITLE_DETAILS}-${index + 1}-other-language-desc`]: item.OtherLanguageDesc || '',
                                  [`${TITLE_DETAILS}-${index + 1}-title`]: item.Title || '',
                                  [`${TITLE_DETAILS}-${index + 1}-romaised-title`]: item.RomanizedTitle || '',
                                  [`${TITLE_DETAILS}-${index + 1}-also-known-as`]: item.AlsoKnownAs || '',
                                  [`${TITLE_DETAILS}-${index + 1}-director`]: item.Director || '',
                                  [`${TITLE_DETAILS}-${index + 1}-producer`]: item.Producer || '',
                                  [`${TITLE_DETAILS}-${index + 1}-main-feature-running-time`]: item.MainFeatureRunTime || '',
                                  [`${TITLE_DETAILS}-${index + 1}-bonus-feature-running-time`]: item.ExtraFeatureRunTime || '',
                                  [`${TITLE_DETAILS}-${index + 1}-nature-of-event-activity`]: item.EventNature || '',
                                  [`${TITLE_DETAILS}-${index + 1}-screening-venue`]: item.ScreeningVenue || '',
                                  [`${TITLE_DETAILS}-${index + 1}-year-production`]: item.ProductionYear || '',
                                  [`${TITLE_DETAILS}-${index + 1}-place-production`]: item.ProductionPlace || '',
                                  [`${TITLE_DETAILS}-${index + 1}-episode-no`]: item.EpisodeNo || ''
                              };
                          }
                      });

                      const languageFields = {
                          [`${TITLE_DETAILS}-language-group`]:
                              dropdownOpts?.LanguageGroup?.find((i: any) => i.optLabel === selectedTitleSearch?.[index]?.languageGroup)
                                  ?.optID ||
                              film.LanguageGroup ||
                              '',
                          [`${TITLE_DETAILS}-sub-language-group`]:
                              dropdownOpts?.SubLanguageGroup?.find((i: any) => i.optLabel === selectedTitleSearch?.[index]?.subLanguage)
                                  ?.optID ||
                              film.SubLanguage ||
                              '',
                          [`${TITLE_DETAILS}-other-language-desc`]:
                              selectedTitleSearch?.[index]?.otherLanguage || film.OtherLanguageDesc || ''
                      };

                      const selectedDeclarationList = film?.PoliticalInformation?.DeclarationList?.filter(
                          (i: any) => i.pySelected === 'true'
                      ).map((i: any) => i.pxSubscript);

                      const iHaveExercisedEditorial = film?.PoliticalInformation?.DeclarationList?.find(
                          (i: any) => i.pxSubscript === '6' && i.pySelected === 'true'
                      );

                      return {
                          id: `${selectedForm}-${index + 1}`,
                          formID: selectedForm,
                          hasError: true,
                          values: {
                              [`${TRAILER_OR_PRODUCT_ADVERTISEMENT_DETAILS}-submission-type`]: film.SubmissionType || '',
                              [`${MOVIE_TRAILER_DETAILS}-submission-type`]: film.SubmissionType || '',

                              [`${IMPORT_DETAILS}-format`]:
                                  film.Format ||
                                  dropdownOpts?.['IMDA-IRIS-Work-Films-Format']?.find(
                                      (i: any) => i.optLabel === selectedTitleSearch?.[index]?.format
                                  )?.optID ||
                                  '',
                              [`${IMPORT_DETAILS}-online-link`]: film.OnlineLink || '',
                              [`${IMPORT_DETAILS}-id-username`]: film.pyUserName || '',
                              [`${IMPORT_DETAILS}-password`]: film.PasswordValue || '',
                              [`${IMPORT_DETAILS}-dateCombo-main`]: film.PreferredDate || '',
                              [`${IMPORT_DETAILS}-dateCombo-radio-day`]: film.PreferredTime || 'AM',
                              [`${IMPORT_DETAILS}-dcp-ready-date`]: film.DCPReadyDate || '',
                              [`${IMPORT_DETAILS}-kdm-required`]: film.IsKeyDeliveryMessageRequired || '',
                              [`${IMPORT_DETAILS}-other-format`]: selectedTitleSearch?.[index]?.otherFormat || film.OtherFormat || '',
                              [`${IMPORT_DETAILS}-no-of-pieces`]: film.NoOfPieces || '',
                              [`${IMPORT_DETAILS}-type`]:
                                  dropdownOpts?.['IMDA-IRIS-Work-Films-Type']?.find(
                                      (i: any) => i.optLabel === selectedTitleSearch?.[index]?.type
                                  )?.optID ||
                                  film.Type ||
                                  '',
                              [`${IMPORT_DETAILS}-box-set`]: film.IsBoxSet || '',
                              [`${IMPORT_DETAILS}-no-of-titles-submission`]: film.NoOfTitles || '',

                              ...filmTitleDetailsList?.reduce((result: any, filmDetails: any) => {
                                  return { ...result, ...filmDetails };
                              }, {}),

                              [`${TITLE_DETAILS}-application-form`]: _content?.ApplicationForm,
                              [`${TITLE_DETAILS}-application-type`]: _content?.ApplicationType,
                              [`${TITLE_DETAILS}-is-existing-title`]:
                                  !film.IsExistingTitle && Object.entries(selectedTitleSearch).length > 0
                                      ? 'Yes'
                                      : film.IsExistingTitle || '',
                              [`${TITLE_DETAILS}-title`]: selectedTitleSearch?.[index]?.title || film.Title || '',
                              [`${TITLE_DETAILS}-romaised-title`]:
                                  selectedTitleSearch?.[index]?.romanizedTitle || film.RomanizedTitle || '',
                              [`${TITLE_DETAILS}-also-known-as`]: selectedTitleSearch?.[index]?.alsoKnownAs || film.AlsoKnownAs || '',
                              [`${TITLE_DETAILS}-director`]: selectedTitleSearch?.[index]?.director || film.Director || '',
                              [`${TITLE_DETAILS}-rating`]: selectedTitleSearch?.[index]?.rating || film.Rating || '',
                              [`${TITLE_DETAILS}-rating-code`]:
                                  dropdownOpts?.['IMDA-IRIS-Work-Films-Rating']?.find(
                                      (i: any) => i.optLabel === selectedTitleSearch?.[index]?.rating
                                  )?.optID ||
                                  film.Rating ||
                                  '',
                              [`${TITLE_DETAILS}-decision`]: selectedTitleSearch?.[index]?.decision || film.Decision || '',
                              [`${TITLE_DETAILS}-decision-code`]:
                                  dropdownOpts?.['IMDA-IRIS-Work-Films-Decision']?.find(
                                      (i: any) => i.optLabel === selectedTitleSearch?.[index]?.decision
                                  )?.optID ||
                                  film.DecisionCode ||
                                  '',
                              [`${TITLE_DETAILS}-original-submission-consumer-advice`]:
                                  selectedTitleSearch?.[index]?.consumerAdvice || film.ConsumerAdvice || '',
                              [`${TITLE_DETAILS}-footage`]: selectedTitleSearch?.[index]?.footage || film.Footage || '',
                              [`${TITLE_DETAILS}-running-time`]: film.RunTime || selectedTitleSearch?.[index]?.runningTime || '',
                              [`${TITLE_DETAILS}-submission-purpose`]: film.PurposeOfSubmission || '',
                              [`${TITLE_DETAILS}-submission-purpose-non-profit`]: film.PurposeOfSubmission || '',
                              [`${TITLE_DETAILS}-nature-of-event-activity`]:
                                  !film.EventNature && isActiveDistributionLicenceCompany.length > 0
                                      ? 'Distributed'
                                      : film.EventNature || '',
                              [`${TITLE_DETAILS}-screening-date`]: [
                                  {
                                      to: film.ScreeningTo,
                                      from: film.ScreeningFrom
                                  }
                              ],
                              [`${TITLE_DETAILS}-screening-venue`]: film.ScreeningVenue,
                              [`${TITLE_DETAILS}-submission-extra-features`]: film.IsSubmissionExtraFeatures,
                              [`${TITLE_DETAILS}-classify-extra-features`]: film.IsExtraFeaturesClassified,

                              // [`${TITLE_DETAILS}-language-group`]: film.LanguageGroup || '',
                              // [`${TITLE_DETAILS}-sub-language-group`]: film.SubLanguage || '',
                              // [`${TITLE_DETAILS}-language-desc`]: film.LanguageDescription || '',

                              ...languageFields,

                              [`${TITLE_DETAILS}-place-production`]: film.ProductionPlace || '',
                              [`${TITLE_DETAILS}-other-place-of-production`]: film.PlaceOfProductionOthers || '',
                              [`${TITLE_DETAILS}-year-production`]: film.ProductionYear || '',
                              [`${TITLE_DETAILS}-producer`]: film.Producer || '',
                              [`${TITLE_DETAILS}-main-feature-running-time`]: film.MainFeatureRunTime || '',
                              [`${TITLE_DETAILS}-bonus-feature-running-time`]: film.ExtraFeatureRunTime || '',

                              [`${SUBTITLES_DETAILS}-subtitle-1`]: film.SubtitleOne || '',
                              [`${SUBTITLES_DETAILS}-subtitle-2`]: film.SubtitleTwo || '',

                              [`${INFORMATION_ON_FILM}-made`]: film?.PoliticalInformation?.MadeByPoliticalParty || '',
                              [`${INFORMATION_ON_FILM}-made-political-name`]: film?.PoliticalInformation?.PoliticalPartyMadeName || '',
                              [`${INFORMATION_ON_FILM}-submitted`]: film?.PoliticalInformation?.SubmittedByPoliticalParty || '',
                              [`${INFORMATION_ON_FILM}-submitted-political-name`]:
                                  film?.PoliticalInformation?.PoliticalPartySubmitName || '',
                              [`${INFORMATION_ON_FILM}-remarks`]: film?.PoliticalInformation?.Remarks || '',
                              [`${INFORMATION_ON_FILM}-checklist`]: selectedDeclarationList?.length <= 0 ? '' : selectedDeclarationList,
                              [`${INFORMATION_ON_FILM}-i-have-exercised-editorial`]: iHaveExercisedEditorial ? 'Yes' : 'No',

                              [`${REMARKS}-remarks`]: film.Remarks || '',
                              [`${REMARKS}-link-to-attachments`]: film.LinkToSupportingDocuments || '',
                              [`${REMARKS}-attachments`]: attachmentRetrieve(film.AttachmentList) || '',

                              [`${EPISODE_DETAILS}-episode-no`]: film.EpisodeNo || '',

                              [`${CA_CLASSIFICATION_DETAILS}-ca-rating`]: film.Rating || '',
                              [`${CA_CLASSIFICATION_DETAILS}-attachments`]: attachmentRetrieve(film.AttachmentList) || '',
                              [`${CA_CLASSIFICATION_DETAILS}-ca-decision`]: film.DecisionCode || '',
                              [`${CA_CLASSIFICATION_DETAILS}-ca-consumer-advice`]: film.ConsumerAdvice || '',
                              [`${CA_CLASSIFICATION_DETAILS}-ca-comments-remarks`]: film.Remarks || '',

                              [`${TITLE_DETAILS}-case-id`]: film.caseid || ''
                          }
                      };
                  })
              );

        const qualificationDetails = _content?.ProfileUpdate?.QualificationDetails;

        academicQualification = {
            id: 'academic-qualification-details',
            formID: 'academicQualifications',
            hasError: true,
            values: {
                [`${ACADEMIC_QUALIFICATION}-name-of-institution`]:
                    qualificationDetails?.Institution || CAProfileDetails?.QualificationDetails?.Institution || '',
                [`${ACADEMIC_QUALIFICATION}-country`]:
                    qualificationDetails?.CountryCode || CAProfileDetails?.QualificationDetails?.CountryCode || '',
                [`${ACADEMIC_QUALIFICATION}-highest-qualification-attained`]:
                    qualificationDetails?.QualificationAttained || CAProfileDetails?.QualificationDetails?.QualificationAttained || '',
                [`${ACADEMIC_QUALIFICATION}-other-qualification-attainted`]:
                    qualificationDetails?.Others || CAProfileDetails?.QualificationDetails?.Others || '',
                [`${ACADEMIC_QUALIFICATION}-name-of-course`]:
                    qualificationDetails?.CourseName || CAProfileDetails?.QualificationDetails?.CourseName || '',
                [`${ACADEMIC_QUALIFICATION}-year-of-completion`]:
                    qualificationDetails?.Year || CAProfileDetails?.QualificationDetails?.Year || '',
                [`${ACADEMIC_QUALIFICATION}-attachments`]: attachmentRetrieve(qualificationDetails?.AttachmentPage?.AttachmentList)
            }
        };

        const languageList = _content?.ProfileUpdate?.LanguageList ||
            CAProfileDetails?.LanguageList || [
                {
                    language: '',
                    'other-language': '',
                    written: '',
                    spoken: ''
                }
            ];

        languageProficiency = {
            id: 'language-proficiency-details',
            formID: 'languageProficiency',
            hasError: true,
            values: {
                [`${LANGUAGE_PROFICIENCY}-language-proficiency`]: languageList?.map((i: any) => {
                    return {
                        language: i.Code,
                        'other-language': i.Language,
                        written: i.CanWrite === 'true' ? 'Yes' : 'No',
                        spoken: i.CanSpeak === 'true' ? 'Yes' : 'No'
                    };
                })
            }
        };

        const employmentDetailss = _content?.ProfileUpdate?.EmploymentDetails;

        employmentDetails = {
            id: 'employment-details',
            formID: 'employmentDetails',
            hasError: true,
            values: {
                [`${CURRENT_EMPLOYMENT_DETAILS}-name-of-employer`]:
                    employmentDetailss?.Name || CAProfileDetails?.EmploymentDetails?.Name || '',
                [`${CURRENT_EMPLOYMENT_DETAILS}-type-of-employment`]:
                    employmentDetailss?.Type || CAProfileDetails?.EmploymentDetails?.Type || '',
                [`${CURRENT_EMPLOYMENT_DETAILS}-current-designation`]:
                    employmentDetailss?.designation || CAProfileDetails?.EmploymentDetails?.designation || '',
                [`${PERIOD_OF_EMPLOYMENT}-start-date`]:
                    employmentDetailss?.StartDateOnly || CAProfileDetails?.EmploymentDetails?.StartDateOnly || '',
                [`${ADDRESS_OF_EMPLOYER}-address`]:
                    employmentDetailss?.AddressString || CAProfileDetails?.EmploymentDetails?.AddressString || '',
                [`${ADDRESS_OF_EMPLOYER}-country`]:
                    employmentDetailss?.CountryCode || CAProfileDetails?.EmploymentDetails?.CountryCode || '',
                [`${ADDRESS_OF_EMPLOYER}-office-no-country-code`]: '65',
                [`${ADDRESS_OF_EMPLOYER}-office-no-main`]:
                    employmentDetailss?.OfficeNumber?.slice(3) || CAProfileDetails?.EmploymentDetails?.OfficeNumber?.startsWith('+')
                        ? CAProfileDetails?.EmploymentDetails?.OfficeNumber?.slice(3)
                        : CAProfileDetails?.EmploymentDetails?.OfficeNumber
            }
        };
    } else {
        const isCAUpdateProfile = _content.ApplicationForm === 'FMUPD' || _content.ApplicationForm === 'Content Assessor Profile Update';

        general = {
            id: 'summary',
            formID: 'summary',
            hasError: true,
            values: {
                [`summary-transactionType`]: _content?.pyStatusCustomerSat,
                [`summary-title`]: _content?.Title,
                [`summary-application-name`]: _content?.ApplicationType,
                [`summary-application-category`]: '',
                [`summary-application-number`]: _content?.ApplicationType,
                [`summary-application-businessStatus`]: _content?.BusinessStatus,
                [`summary-application-submission`]: _content?.pxCommitDateTime,
                [`summary-gbl-id`]: _content?.IDNo,
                [`summary-id`]: _content?.caseid,
                [`summary-status`]: _content?.CustomerStatus,
                [`summary-start-date`]: '',
                [`summary-expiry-date`]: '',
                [`summary-date-submission`]: formatDateTime(_content?.pxCreateDateTime ?? '', true),
                caseID: _content?.caseid
            }
        };

        organisation = {
            id: general_selected,
            formID: general_selected,
            hasError: true,
            title: general_selected === 'generalApplicant' ? 'Applicant Details' : 'Applicant/Organisation Details',
            values: {
                [`${SECT_APPLICANT}-application-type`]: _content?.ApplicationType,

                [`${SECT_APPLICANT}-id-type`]: applicantValues?.IDType,
                [`${SECT_APPLICANT}-idno`]: applicantValues?.IDNo,
                [`${SECT_APPLICANT}-salutaion`]: applicantValues?.Salutation,
                [`${SECT_APPLICANT}-name`]: applicantValues?.Name,
                [`${SECT_APPLICANT}-email`]: applicantContact?.EmailAddress,
                [`${SECT_APPLICANT}-email-published-online`]: applicantContact?.PublishEmailAddress,
                [`${SECT_APPLICANT}-other-email`]: applicantContact?.OtherEmailAddress,
                [`${SECT_APPLICANT}-mobile-no-main`]: applicantContact?.ContactNumber?.startsWith('+65')
                    ? applicantContact?.ContactNumber?.slice(3)
                    : applicantContact?.ContactNumber,
                [`${SECT_APPLICANT}-mobile-no-country-code`]: applicantContact?.MobileNoCountryCode || '65',
                [`${SECT_APPLICANT}-other-mobile-no-main`]: applicantContact?.OtherContactNumber?.startsWith('+65')
                    ? applicantContact?.OtherContactNumber?.slice(3)
                    : applicantContact?.OtherContactNumber,
                [`${SECT_APPLICANT}-other-mobile-no-country-code`]: applicantContact?.OtherPhoneNumberCountryCode || '65',
                // [`${SECT_APPLICANT}-nationality`]: applicantValues?.Nationality,

                [`${ORGANISATION_DETAILS}-organisation-uen-no`]: companyValues?.UEN,
                [`${ORGANISATION_DETAILS}-organisation-name`]: companyValues?.CompanyName,
                [`${ORGANISATION_DETAILS}-organisation-mobile-no-main`]: companyContact?.MobileNo?.startsWith('+65')
                    ? companyContact?.MobileNo?.slice(3)
                    : companyContact?.MobileNo,
                [`${ORGANISATION_DETAILS}-organisation-mobile-no-country-code`]: companyContact?.MobileNoCountryCode || '65',
                [`${ORGANISATION_DETAILS}-organisation-email`]: companyContact?.EmailAddress,
                [`${ORGANISATION_DETAILS}-other-organisation-email`]: companyContact?.OtherEmailAddress,

                [`${SECT_ADDRESS}-postal`]: applicantValues?.MailingAddress?.PostalCode || companyValues?.MailingAddress?.PostalCode,
                [`${SECT_ADDRESS}-block-house`]: applicantValues?.MailingAddress?.BlockNumber || companyValues?.MailingAddress?.BlockNumber,
                [`${SECT_ADDRESS}-street`]: applicantValues?.MailingAddress?.StreetName || companyValues?.MailingAddress?.StreetName,
                [`${SECT_ADDRESS}-floor`]: applicantValues?.MailingAddress?.FloorNumber || companyValues?.MailingAddress?.FloorNumber,
                [`${SECT_ADDRESS}-unit`]: applicantValues?.MailingAddress?.UnitNumber || companyValues?.MailingAddress?.UnitNumber,
                [`${SECT_ADDRESS}-building`]: applicantValues?.MailingAddress?.BuildingName || companyValues?.MailingAddress?.BuildingName,

                CustomerStatus: _content?.CustomerStatus,
                BusinessStatus: _content?.pyStatusWork,
                CaseRefKey: _content?.pzInsKey,
                transactionType: _content?.pyStatusCustomerSat
            }
        };

        const filmTitleDetailsList = _content?.FilmTitleDetailsBoxset?.map((item: any, index: number) => {
            if (_content?.FilmTitleDetails.IsBoxSet === 'Yes') {
                return {
                    [`${TITLE_DETAILS}-${index + 1}-language-group`]: item.LanguageGroup || '',
                    [`${TITLE_DETAILS}-${index + 1}-sub-language-group`]: item.SubLanguage || '',
                    [`${TITLE_DETAILS}-${index + 1}-other-language-desc`]: item.OtherLanguageDesc || '',
                    [`${TITLE_DETAILS}-${index + 1}-title`]: item.Title || '',
                    [`${TITLE_DETAILS}-${index + 1}-romaised-title`]: item.RomanizedTitle || '',
                    [`${TITLE_DETAILS}-${index + 1}-also-known-as`]: item.AlsoKnownAs || '',
                    [`${TITLE_DETAILS}-${index + 1}-director`]: item.Director || '',
                    [`${TITLE_DETAILS}-${index + 1}-producer`]: item.Producer || '',
                    [`${TITLE_DETAILS}-${index + 1}-main-feature-running-time`]: item.MainFeatureRunTime || '',
                    [`${TITLE_DETAILS}-${index + 1}-bonus-feature-running-time`]: item.ExtraFeatureRunTime || '',
                    [`${TITLE_DETAILS}-${index + 1}-nature-of-event-activity`]: item.EventNature || '',
                    [`${TITLE_DETAILS}-${index + 1}-screening-venue`]: item.ScreeningVenue || '',
                    [`${TITLE_DETAILS}-${index + 1}-year-production`]: item.ProductionYear || '',
                    [`${TITLE_DETAILS}-${index + 1}-place-production`]: item.ProductionPlace || '',
                    [`${TITLE_DETAILS}-${index + 1}-episode-no`]: item.EpisodeNo || ''
                };
            }
        });

        const selectedDeclarationList = _content?.FilmTitleDetails?.PoliticalInformation?.DeclarationList?.filter(
            (i: any) => i.pySelected === 'true'
        ).map((i: any) => i.pxSubscript);

        const iHaveExercisedEditorial = _content?.FilmTitleDetails?.PoliticalInformation?.DeclarationList?.find(
            (i: any) => i.pxSubscript === '6' && i.pySelected === 'true'
        );

        const questionList = _content?.QuestionListPage || [];

        const title = _content?.ApplicationType === 'Content Assessor (CA) Registration/Renewal' ? 'Application Details' : 'Film Details';
        const combinedAttachments = [
            ...(_content?.FilmTitleDetails?.AttachmentList || []),
            ...(_content?.NonProfitDeclarationDetails?.AttachmentList || [])
        ];
        applicationFilm = [
            {
                id: `${selectFormFilm(_content?.ApplicationForm)}`,
                formID: `${selectFormFilm(_content?.ApplicationForm)}`,
                hasError: true,
                title,
                values: {
                    CustomerStatus: _content?.CustomerStatus,
                    [`${TRAILER_OR_PRODUCT_ADVERTISEMENT_DETAILS}-submission-type`]: _content?.FilmTitleDetails?.SubmissionType || '',
                    [`${MOVIE_TRAILER_DETAILS}-submission-type`]: _content?.FilmTitleDetails?.SubmissionType || '',
                    [`${IMPORT_DETAILS}-format`]: _content?.FilmTitleDetails?.Format || '',
                    [`${IMPORT_DETAILS}-online-link`]: _content?.FilmTitleDetails?.OnlineLink || '',
                    [`${IMPORT_DETAILS}-id-username`]: _content?.FilmTitleDetails?.pyUserName || '',
                    [`${IMPORT_DETAILS}-password`]: _content?.FilmTitleDetails?.PasswordValue || '',
                    [`${IMPORT_DETAILS}-dateCombo-main`]: _content?.FilmTitleDetails?.PreferredDate || '',
                    [`${IMPORT_DETAILS}-dateCombo-radio-day`]: _content?.FilmTitleDetails?.PreferredTime || '',
                    [`${IMPORT_DETAILS}-dcp-ready-date`]: _content?.FilmTitleDetails?.DCPReadyDate || '',
                    [`${IMPORT_DETAILS}-kdm-required`]: _content?.FilmTitleDetails?.IsKeyDeliveryMessageRequired || '',
                    [`${IMPORT_DETAILS}-other-format`]: _content?.FilmTitleDetails?.OtherFormat || '',
                    [`${IMPORT_DETAILS}-no-of-pieces`]: _content?.FilmTitleDetails?.NoOfPieces || '',
                    [`${IMPORT_DETAILS}-type`]: _content?.FilmTitleDetails?.Type || '',
                    [`${IMPORT_DETAILS}-box-set`]: _content?.FilmTitleDetails?.IsBoxSet || '',
                    [`${IMPORT_DETAILS}-no-of-titles-submission`]: _content?.FilmTitleDetails?.NoOfTitles,

                    ...filmTitleDetailsList?.reduce((result: any, filmDetails: any) => {
                        return { ...result, ...filmDetails };
                    }, {}),

                    [`${TITLE_DETAILS}-title`]: _content?.FilmTitleDetails?.Title || '',
                    [`${TITLE_DETAILS}-romaised-title`]: _content?.FilmTitleDetails?.RomanizedTitle || '',
                    [`${TITLE_DETAILS}-also-known-as`]: _content?.FilmTitleDetails?.AlsoKnownAs || '',
                    [`${TITLE_DETAILS}-director`]: _content?.FilmTitleDetails?.Director || '',
                    [`${TITLE_DETAILS}-rating`]: _content?.FilmTitleDetails?.Rating || '',
                    [`${TITLE_DETAILS}-decision`]: _content?.FilmTitleDetails?.Decision || '',
                    [`${TITLE_DETAILS}-original-submission-consumer-advice`]: _content?.FilmTitleDetails?.ConsumerAdvice || '',
                    [`${TITLE_DETAILS}-footage`]: _content?.FilmTitleDetails?.Footage || '',
                    [`${TITLE_DETAILS}-place-production`]: _content?.FilmTitleDetails?.ProductionPlace || '',
                    [`${TITLE_DETAILS}-other-place-of-production`]: _content?.FilmTitleDetails?.PlaceOfProductionOthers || '',
                    [`${TITLE_DETAILS}-year-production`]: _content?.FilmTitleDetails?.ProductionYear || '',
                    [`${TITLE_DETAILS}-producer`]: _content?.FilmTitleDetails?.Producer || '',

                    [`${TITLE_DETAILS}-running-time`]: _content?.FilmTitleDetails?.RunTime || '',
                    [`${TITLE_DETAILS}-submission-purpose`]: _content?.FilmTitleDetails?.PurposeOfSubmission || '',
                    [`${TITLE_DETAILS}-nature-of-event-activity`]: _content?.FilmTitleDetails?.EventNature || '',
                    [`${TITLE_DETAILS}-submission-extra-features`]: _content?.FilmTitleDetails?.IsSubmissionExtraFeatures || '',
                    [`${TITLE_DETAILS}-classify-extra-features`]: _content?.FilmTitleDetails?.IsExtraFeaturesClassified || '',
                    [`${TITLE_DETAILS}-screening-date`]: [
                        {
                            to: _content?.FilmTitleDetails?.ScreeningTo,
                            from: _content?.FilmTitleDetails?.ScreeningFrom
                        }
                    ],
                    [`${TITLE_DETAILS}-screening-venue`]: _content?.FilmTitleDetails?.ScreeningVenue,
                    [`${TITLE_DETAILS}-language-group`]: _content?.FilmTitleDetails?.LanguageGroup || '',
                    [`${TITLE_DETAILS}-sub-language-group`]: _content.FilmTitleDetails?.SubLanguage || '',
                    [`${TITLE_DETAILS}-other-language-desc`]: _content?.FilmTitleDetails?.OtherLanguageDesc || '',
                    [`${TITLE_DETAILS}-main-feature-running-time`]: _content?.FilmTitleDetails?.MainFeatureRunTime || '',
                    [`${TITLE_DETAILS}-bonus-feature-running-time`]: _content?.FilmTitleDetails?.ExtraFeatureRunTime || '',

                    [`${SUBTITLES_DETAILS}-subtitle-1`]: _content?.FilmTitleDetails?.SubtitleOne || '',
                    [`${SUBTITLES_DETAILS}-subtitle-2`]: _content?.FilmTitleDetails?.SubtitleTwo || '',

                    [`${INFORMATION_ON_FILM}-made`]: _content?.FilmTitleDetails?.PoliticalInformation?.MadeByPoliticalParty || '',
                    [`${INFORMATION_ON_FILM}-made-political-name`]:
                        _content?.FilmTitleDetails?.PoliticalInformation?.PoliticalPartyMadeName || '',
                    [`${INFORMATION_ON_FILM}-submitted`]: _content?.FilmTitleDetails?.PoliticalInformation?.SubmittedByPoliticalParty || '',
                    [`${INFORMATION_ON_FILM}-submitted-political-name`]:
                        _content?.FilmTitleDetails?.PoliticalInformation?.PoliticalPartySubmitName || '',
                    [`${INFORMATION_ON_FILM}-remarks`]: _content?.FilmTitleDetails?.PoliticalInformation?.Remarks || '',
                    [`${INFORMATION_ON_FILM}-checklist`]: selectedDeclarationList?.length <= 0 ? '' : selectedDeclarationList,
                    [`${INFORMATION_ON_FILM}-i-have-exercised-editorial`]: iHaveExercisedEditorial ? 'Yes' : 'No',

                    [`${REMARKS}-remarks`]: _content?.FilmTitleDetails?.Remarks || '',
                    [`${REMARKS}-link-to-attachments`]: _content?.FilmTitleDetails?.LinkToSupportingDocuments || '',
                    [`${REMARKS}-attachments`]: _content?.IsManuallyCreated === 'true' ? '' : attachmentRetrieve(combinedAttachments) || '',

                    [`${EPISODE_DETAILS}-episode-no`]: _content?.FilmTitleDetails?.EpisodeNo || '',

                    [`${CA_CLASSIFICATION_DETAILS}-ca-rating`]: _content?.FilmTitleDetails?.Rating || '',
                    [`${CA_CLASSIFICATION_DETAILS}-attachments`]:
                        _content?.IsManuallyCreated === 'true' ? '' : attachmentRetrieve(_content?.FilmTitleDetails?.AttachmentList) || '',
                    [`${CA_CLASSIFICATION_DETAILS}-ca-decision`]: _content?.FilmTitleDetails?.DecisionCode || '',
                    [`${CA_CLASSIFICATION_DETAILS}-ca-consumer-advice`]: _content?.FilmTitleDetails?.ConsumerAdvice || '',
                    [`${CA_CLASSIFICATION_DETAILS}-ca-comments-remarks`]: _content?.FilmTitleDetails?.Remarks || '',

                    [`${CONTENT_ASSESSOR_REGISTRATION}-question-1`]: questionList[0]?.AnswerPage?.Answer || '',
                    [`${CONTENT_ASSESSOR_REGISTRATION}-question-1-remarks`]: questionList[0]?.AnswerPage?.Remarks || '',
                    [`${CONTENT_ASSESSOR_REGISTRATION}-question-2`]: questionList[1]?.AnswerPage?.Answer || '',
                    [`${CONTENT_ASSESSOR_REGISTRATION}-question-2-remarks`]: questionList[1]?.AnswerPage?.Remarks || '',
                    [`${CONTENT_ASSESSOR_REGISTRATION}-question-3`]: questionList[2]?.AnswerPage?.Answer || '',
                    [`${CONTENT_ASSESSOR_REGISTRATION}-question-3-remarks`]: questionList[2]?.AnswerPage?.Remarks || '',
                    [`${CONTENT_ASSESSOR_REGISTRATION}-attachments`]: attachmentRetrieve(_content?.AttachmentPage?.AttachmentList) || '',
                    [`${CONTENT_ASSESSOR_REGISTRATION}-link-to-attachments`]: _content?.AttachmentPage?.LinkToAttachments || ''
                }
            }
        ];

        const qualificationDetails = _content?.ProfileUpdate?.QualificationDetails;
        const languageList = _content?.ProfileUpdate?.LanguageList || [
            {
                language: '',
                'other-language': '',
                written: '',
                spoken: ''
            }
        ];
        const employmentDetailss = _content?.ProfileUpdate?.EmploymentDetails;

        rcaRegistrationDetails = {
            id: 'rca-registration-details',
            formID: 'rcaRegistrationDetails',
            title: 'Application Details',
            hasError: true,
            values: {
                [`${ACADEMIC_QUALIFICATION}-case-id`]: _content.caseid,
                [`${ACADEMIC_QUALIFICATION}-name-of-institution`]: qualificationDetails?.Institution || '',
                [`${ACADEMIC_QUALIFICATION}-country`]: qualificationDetails?.CountryCode || '',
                [`${ACADEMIC_QUALIFICATION}-highest-qualification-attained`]: qualificationDetails?.QualificationAttained || '',
                [`${ACADEMIC_QUALIFICATION}-other-qualification-attainted`]: qualificationDetails?.Others || '',
                [`${ACADEMIC_QUALIFICATION}-name-of-course`]: qualificationDetails?.CourseName || '',
                [`${ACADEMIC_QUALIFICATION}-year-of-completion`]: qualificationDetails?.Year || '',
                [`${ACADEMIC_QUALIFICATION}-attachments`]: attachmentRetrieve(qualificationDetails?.AttachmentPage?.AttachmentList) || '',

                [`${LANGUAGE_PROFICIENCY}-language-proficiency`]: languageList?.map((i: any) => {
                    return {
                        language: i.Code,
                        'other-language': i.Language,
                        written: i.CanWrite,
                        spoken: i.CanSpeak
                    };
                }),

                [`${CURRENT_EMPLOYMENT_DETAILS}-name-of-employer`]: employmentDetailss?.Name,
                [`${CURRENT_EMPLOYMENT_DETAILS}-type-of-employment`]: employmentDetailss?.Type,
                [`${CURRENT_EMPLOYMENT_DETAILS}-current-designation`]: employmentDetailss?.designation,
                [`${PERIOD_OF_EMPLOYMENT}-start-date`]: employmentDetailss?.StartDateOnly,
                [`${ADDRESS_OF_EMPLOYER}-address`]: employmentDetailss?.AddressString,
                [`${ADDRESS_OF_EMPLOYER}-country`]: employmentDetailss?.CountryCode,
                [`${ADDRESS_OF_EMPLOYER}-office-no-country-code`]: '65',
                [`${ADDRESS_OF_EMPLOYER}-office-no-main`]: employmentDetailss?.OfficeNumber?.slice(3)
            }
        };

        return [
            general,
            organisation,
            ...(!isCAUpdateProfile ? applicationFilm || [] : []),
            ...(isCAUpdateProfile ? [rcaRegistrationDetails] : [])
        ];
    }

    return [
        general,
        ...(!isCAUpdateProfile ? applicationFilm || [] : []),
        ...(isCAUpdateProfile ? [academicQualification] : []),
        ...(isCAUpdateProfile ? [languageProficiency] : []),
        ...(isCAUpdateProfile ? [employmentDetails] : [])
    ];
};

// eslint-disable-next-line complexity
export const formatSave = async (
    details: DetailsType,
    caseTypeID: string,
    applicationForm?: string,
    applicationType?: string,
    pageInstructions: any[] = [],
    userRole?: string,
    action?: string,
    _selectedTitleSearch?: any,
    content?: any,
    CAProfileUUID?: string,
    existingTitle?: string
) => {
    if (action === 'application-delete') return payloadDeleteApplication;
    const selectedForm = selectFormFilm(applicationForm ?? '', applicationType);

    const isCA = applicationType === 'Content Assessor (CA) Registration/Renewal';
    const isCAUpdateProfile = applicationForm === 'FMUPD' || applicationForm === 'Content Assessor Profile Update';
    const general = details.forms.find((form: FormData) => form.id === 'generalApplicant' || form.id === 'generalCompany')?.values || {};
    const films = details.forms.filter((form: FormData) => form.formID === selectedForm);
    const CARegistration = details.forms.find((form: FormData) => form.formID === 'contentAssessorRegistration')?.values || {};
    const AcademicQualification = details.forms.find((form: FormData) => form.formID === 'academicQualifications')?.values || {};
    const LanguageProficiency = details.forms.find((form: FormData) => form.formID === 'languageProficiency')?.values || {};
    const EmploymentDetails = details.forms.find((form: FormData) => form.formID === 'employmentDetails')?.values || {};
    const filmsPendingKDM = details.forms.filter((form: FormData) => form.formID === 'submissionOfPendingKDM');

    let CADraftTitle;
    if (applicationForm === 'FMREG') {
        CADraftTitle = 'Content Assessor Registration';
    } else if (applicationForm === 'FMREN') {
        CADraftTitle = 'Content Assessor Renewal';
    } else if (applicationForm === 'FMUPD') {
        CADraftTitle = 'Content Assessor Profile Update';
    }

    const caseID = content?.caseid;

    if (action === 'kdm' || action === 'submissionOfPendingKDM') {
        const filmsPendingValues = filmsPendingKDM.map((film) => {
            return film?.values || {};
        });

        return {
            caseid: caseID,
            AttachmentList: attachmentPayloadSetting((filmsPendingValues[0]?.[`${PENDING_KDM}-attachments`] || []) as Attachment[]),
            KDMLink: filmsPendingValues[0]?.[`${PENDING_KDM}-link-to-attachments`] || '',
            Remarks: filmsPendingValues[0]?.[`${PENDING_KDM}-remarks`] || ''
        };
    }

    const otherContactNumber = general[`${SECT_APPLICANT}-other-mobile-no-main`];
    const languageProficiency = (LanguageProficiency[`${LANGUAGE_PROFICIENCY}-language-proficiency`] as { [key: string]: string }[]) || [];

    return {
        caseTypeID,
        content: {
            LoginType: userRole,
            UEN: general[`${ORGANISATION_DETAILS}-organisation-uen-no`] || '',
            applicant: {
                IDNo: general[`${SECT_APPLICANT}-idno`] || '',
                IDType:
                    general[`${SECT_APPLICANT}-id-type`] === 'IDT' ? 'NRIC' : general[`${SECT_APPLICANT}-id-type`] === 'IDT2' ? 'FIN' : '',
                pxObjClass: 'IMDA-Data-Applicant',
                Salutation: general[`${SECT_APPLICANT}-salutaion`] || '',
                Name: general[`${SECT_APPLICANT}-name`] || '',
                // Nationality: general[`${SECT_APPLICANT}-nationality`] || '',
                // Address: [
                //     {
                //         pxObjClass: 'IMDA-Data-Address',
                //         MailingAddress: {
                //             BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                //             BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                //             FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                //             UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                //             PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                //             pxObjClass: 'IMDA-Data-Address',
                //             StreetName: general[`${SECT_ADDRESS}-street`] || ''
                //         }
                //     }
                // ],
                MailingAddress: {
                    BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                    BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                    FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                    UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                    PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                    pxObjClass: 'IMDA-Data-Address',
                    StreetName: general[`${SECT_ADDRESS}-street`] || ''
                },
                ContactPage: {
                    EmailAddress: general[`${SECT_APPLICANT}-email`] || '',
                    ...(isCA && {
                        PublishEmailAddress: general[`${SECT_APPLICANT}-email-published-online`] || ''
                    }),
                    OtherEmailAddress: general[`${SECT_APPLICANT}-other-email`] || '',
                    // MobileNoCountryCode: general[`${SECT_APPLICANT}-mobile-no-country-code`] || '',
                    ContactNumber:
                        '+' +
                            general[`${SECT_APPLICANT}-mobile-no-country-code`] +
                            general[`${SECT_APPLICANT}-mobile-no-main`].toString() || '',
                    ...(otherContactNumber !== '' && {
                        OtherContactNumber:
                            '+' +
                                general[`${SECT_APPLICANT}-other-mobile-no-country-code`] +
                                general[`${SECT_APPLICANT}-other-mobile-no-main`].toString() || ''
                    }),
                    pxObjClass: 'IMDA-Data-Contact'
                }
            },
            ...(userRole === 'corppass' && {
                company: {
                    CompanyName: general[`${ORGANISATION_DETAILS}-organisation-name`] || '',
                    UEN: general[`${ORGANISATION_DETAILS}-organisation-uen-no`] || '',
                    // Address: [
                    //     {
                    //         pxObjClass: 'IMDA-Data-Address',
                    //         MailingAddress: {
                    //             BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                    //             BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                    //             FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                    //             UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                    //             PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                    //             pxObjClass: 'IMDA-Data-Address',
                    //             StreetName: general[`${SECT_ADDRESS}-street`] || ''
                    //         }
                    //     }
                    // ],
                    MailingAddress: {
                        BlockNumber: general[`${SECT_ADDRESS}-block-house`] || '',
                        BuildingName: general[`${SECT_ADDRESS}-building`] || '',
                        FloorNumber: general[`${SECT_ADDRESS}-floor`] || '',
                        UnitNumber: general[`${SECT_ADDRESS}-unit`] || '',
                        PostalCode: general[`${SECT_ADDRESS}-postal`] || '',
                        pxObjClass: 'IMDA-Data-Address',
                        StreetName: general[`${SECT_ADDRESS}-street`] || ''
                    },
                    ContactPage: {
                        // MobileNo: general[`${ORGANISATION_DETAILS}-organisation-mobile-no-main`] || '',
                        // MobileNoCountryCode: general[`${ORGANISATION_DETAILS}-organisation-mobile-no-country-code`] || '',
                        ContactNumber:
                            '+' +
                                general[`${ORGANISATION_DETAILS}-organisation-mobile-no-country-code`] +
                                general[`${ORGANISATION_DETAILS}-organisation-mobile-no-main`].toString() || '',
                        EmailAddress: general[`${ORGANISATION_DETAILS}-organisation-email`] || '',
                        OtherEmailAddress: general[`${ORGANISATION_DETAILS}-other-organisation-email`] || '',
                        pxObjClass: 'IMDA-Data-Contact'
                    }
                }
            }),
            IDNo: general[`${SECT_APPLICANT}-idno`] || '',
            DraftTitle: isCA ? CADraftTitle : films?.map((film) => (film.values ? film.values[`${TITLE_DETAILS}-title`] : '')).join(', '),
            ...(!isCA && {
                FilmTitleList: films?.map((film) => {
                    const filmValues = film?.values || {};
                    const dateAndTime = (filmValues[`${TITLE_DETAILS}-screening-date`] as { [key: string]: FieldValue }[]) || [];

                    let filmTitleDetailsList = [];
                    const isBoxSet = filmValues['import-details-box-set'];
                    const noOfTitles = filmValues['import-details-no-of-titles-submission'];

                    if (isBoxSet === 'Yes') {
                        for (let i = 0; i < Number(noOfTitles); i++) {
                            filmTitleDetailsList.push({
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-${i + 1}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-${i + 1}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-${i + 1}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-${i + 1}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-${i + 1}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-${i + 1}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-${i + 1}-director`] || '',
                                MainFeatureRunTime: filmValues[`${TITLE_DETAILS}-${i + 1}-main-feature-running-time`] || '',
                                ExtraFeatureRunTime: filmValues[`${TITLE_DETAILS}-${i + 1}-bonus-feature-running-time`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-${i + 1}-nature-of-event-activity`] || ''
                            });
                        }
                    }

                    switch (selectedForm) {
                        /* FILMS EXHIBITION */
                        // FMFA
                        case 'submissionOfNewTitles':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                PurposeOfSubmission:
                                    filmValues[`${TITLE_DETAILS}-submission-purpose`] ||
                                    filmValues[`${TITLE_DETAILS}-submission-purpose-non-profit`] ||
                                    '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                ScreeningFrom: dateAndTime.length > 0 ? dateAndTime[0].from : '',
                                ScreeningTo: dateAndTime.length > 0 ? dateAndTime[0].to : '',
                                ScreeningVenue: filmValues[`${TITLE_DETAILS}-screening-venue`] || '',
                                SubtitleOne: filmValues[`${SUBTITLES_DETAILS}-subtitle-1`] || '',
                                SubtitleTwo: filmValues[`${SUBTITLES_DETAILS}-subtitle-2`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        // FMTA
                        case 'submissionofTrailers/PromotionaMaterials':
                            return {
                                SubmissionType: filmValues[`${MOVIE_TRAILER_DETAILS}-submission-type`] || '',
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || '',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                PurposeOfSubmission:
                                    filmValues[`${TITLE_DETAILS}-submission-purpose`] ||
                                    filmValues[`${TITLE_DETAILS}-submission-purpose-non-profit`] ||
                                    '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                // IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                // IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                ScreeningFrom: dateAndTime.length > 0 ? dateAndTime[0].from : '',
                                ScreeningTo: dateAndTime.length > 0 ? dateAndTime[0].to : '',
                                ScreeningVenue: filmValues[`${TITLE_DETAILS}-screening-venue`] || '',
                                SubtitleOne: filmValues[`${SUBTITLES_DETAILS}-subtitle-1`] || '',
                                SubtitleTwo: filmValues[`${SUBTITLES_DETAILS}-subtitle-2`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        // FMFRT
                        case 'submissionofRepeatTitlesWithIdenticalContent':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                Rating: filmValues[`${TITLE_DETAILS}-rating-code`] || '',
                                DecisionCode: filmValues[`${TITLE_DETAILS}-decision-code`] || '',
                                ConsumerAdvice: filmValues[`${TITLE_DETAILS}-original-submission-consumer-advice`] || '',
                                // Footage: filmValues[`${TITLE_DETAILS}-footage`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                PurposeOfSubmission:
                                    filmValues[`${TITLE_DETAILS}-submission-purpose`] ||
                                    filmValues[`${TITLE_DETAILS}-submission-purpose-non-profit`] ||
                                    '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                // IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                // IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                ScreeningFrom: dateAndTime.length > 0 ? dateAndTime[0].from : '',
                                ScreeningTo: dateAndTime.length > 0 ? dateAndTime[0].to : '',
                                ScreeningVenue: filmValues[`${TITLE_DETAILS}-screening-venue`] || '',
                                SubtitleOne: filmValues[`${SUBTITLES_DETAILS}-subtitle-1`] || '',
                                SubtitleTwo: filmValues[`${SUBTITLES_DETAILS}-subtitle-2`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        // FMFXA
                        case 'submissionofNewTitlesForExpressService':
                            return {
                                /*  SubmissionType: 'Movie Trailer', */
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                PurposeOfSubmission: filmValues[`${TITLE_DETAILS}-submission-purpose`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                ScreeningFrom: dateAndTime.length > 0 ? dateAndTime[0].from : '',
                                ScreeningTo: dateAndTime.length > 0 ? dateAndTime[0].to : '',
                                ScreeningVenue: filmValues[`${TITLE_DETAILS}-screening-venue`] || '',
                                SubtitleOne: filmValues[`${SUBTITLES_DETAILS}-subtitle-1`] || '',
                                SubtitleTwo: filmValues[`${SUBTITLES_DETAILS}-subtitle-2`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        // FMFR
                        case 'submissionofTitlesForRe-classification':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                Rating: filmValues[`${TITLE_DETAILS}-rating-code`] || '',
                                DecisionCode: filmValues[`${TITLE_DETAILS}-decision-code`] || '',
                                ConsumerAdvice: filmValues[`${TITLE_DETAILS}-original-submission-consumer-advice`] || '',
                                // Footage: filmValues[`${TITLE_DETAILS}-footage`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                PurposeOfSubmission:
                                    filmValues[`${TITLE_DETAILS}-submission-purpose`] ||
                                    filmValues[`${TITLE_DETAILS}-submission-purpose-non-profit`] ||
                                    '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                // IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                // IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                ScreeningFrom: dateAndTime.length > 0 ? dateAndTime[0].from : '',
                                ScreeningTo: dateAndTime.length > 0 ? dateAndTime[0].to : '',
                                ScreeningVenue: filmValues[`${TITLE_DETAILS}-screening-venue`] || '',
                                SubtitleOne: filmValues[`${SUBTITLES_DETAILS}-subtitle-1`] || '',
                                SubtitleTwo: filmValues[`${SUBTITLES_DETAILS}-subtitle-2`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        // FMFP
                        case 'submissionOfFilmsWithPartyPoliticalContent':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Producer: filmValues[`${TITLE_DETAILS}-producer`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                PurposeOfSubmission:
                                    filmValues[`${TITLE_DETAILS}-submission-purpose`] ||
                                    filmValues[`${TITLE_DETAILS}-submission-purpose-non-profit`] ||
                                    '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                // IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                // IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                ScreeningFrom: dateAndTime.length > 0 ? dateAndTime[0].from : '',
                                ScreeningTo: dateAndTime.length > 0 ? dateAndTime[0].to : '',
                                ScreeningVenue: filmValues[`${TITLE_DETAILS}-screening-venue`] || '',
                                SubtitleOne: filmValues[`${SUBTITLES_DETAILS}-subtitle-1`] || '',
                                SubtitleTwo: filmValues[`${SUBTITLES_DETAILS}-subtitle-2`] || '',
                                ProductionYear: filmValues[`${TITLE_DETAILS}-year-production`] || '',
                                ProductionPlace: filmValues[`${TITLE_DETAILS}-place-production`] || '',
                                PlaceOfProductionOthers: filmValues[`${TITLE_DETAILS}-other-place-of-production`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[]),
                                PoliticalInformation: {
                                    MadeByPoliticalParty: filmValues[`${INFORMATION_ON_FILM}-made`] || '',
                                    PoliticalPartyMadeName: filmValues[`${INFORMATION_ON_FILM}-made-political-name`] || '',
                                    SubmittedByPoliticalParty: filmValues[`${INFORMATION_ON_FILM}-submitted`] || '',
                                    PoliticalPartySubmitName: filmValues[`${INFORMATION_ON_FILM}-submitted-political-name`] || '',
                                    DeclarationList: [
                                        {
                                            pxSubscript: '1',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '1')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '2',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '2')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '3',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '3')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '4',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '4')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '5',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '5')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '6',
                                            pySelected:
                                                filmValues[`${INFORMATION_ON_FILM}-i-have-exercised-editorial`] === 'Yes'
                                                    ? 'true'
                                                    : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        }
                                    ],
                                    Remarks: filmValues[`${INFORMATION_ON_FILM}-remarks`] || ''
                                }
                            };
                            break;
                        // FMSA
                        case 'submissionofTitlesToObtainAnIndicativeRating':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                // IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                EpisodeNo: filmValues[`${EPISODE_DETAILS}-episode-no`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        /* FILMS DISTRIBUTION */
                        // FMA
                        case 'submissionOfNewTitlesDistribution':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                IsBoxSet: filmValues[`${IMPORT_DETAILS}-box-set`] || '',
                                NoOfTitles: filmValues[`${IMPORT_DETAILS}-no-of-titles-submission`] || '',
                                FilmTitleDetailsList: filmTitleDetailsList,
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                MainFeatureRunTime: filmValues[`${TITLE_DETAILS}-main-feature-running-time`] || '',
                                ExtraFeatureRunTime: filmValues[`${TITLE_DETAILS}-bonus-feature-running-time`] || '',
                                EpisodeNo: filmValues[`${EPISODE_DETAILS}-episode-no`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        case 'submissionofRepeatTitlesWithIdenticalContentDistribution':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                Rating: filmValues[`${TITLE_DETAILS}-rating-code`] || '',
                                DecisionCode: filmValues[`${TITLE_DETAILS}-decision-code`] || '',
                                ConsumerAdvice: filmValues[`${TITLE_DETAILS}-original-submission-consumer-advice`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                EpisodeNo: filmValues[`${EPISODE_DETAILS}-episode-no`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        case 'submissionofClassifiedTitlesWithNewExtraFeaturesDistribution':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                Rating: filmValues[`${TITLE_DETAILS}-rating-code`] || '',
                                DecisionCode: filmValues[`${TITLE_DETAILS}-decision-code`] || '',
                                ConsumerAdvice: filmValues[`${TITLE_DETAILS}-original-submission-consumer-advice`] || '',
                                MainFeatureRunTime: filmValues[`${TITLE_DETAILS}-main-feature-running-time`] || '',
                                ExtraFeatureRunTime: filmValues[`${TITLE_DETAILS}-bonus-feature-running-time`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                EpisodeNo: filmValues[`${EPISODE_DETAILS}-episode-no`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        case 'submissionofNewTitlesForExpressServiceDistribution':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                IsBoxSet: filmValues[`${IMPORT_DETAILS}-box-set`] || '',
                                NoOfTitles: filmValues[`${IMPORT_DETAILS}-no-of-titles-submission`] || '',
                                FilmTitleDetailsList: filmTitleDetailsList,
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                MainFeatureRunTime: filmValues[`${TITLE_DETAILS}-main-feature-running-time`] || '',
                                ExtraFeatureRunTime: filmValues[`${TITLE_DETAILS}-bonus-feature-running-time`] || '',
                                EpisodeNo: filmValues[`${EPISODE_DETAILS}-episode-no`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        case 'submissionofTitlesForRe-classificationDistribution':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                IsBoxSet: filmValues[`${IMPORT_DETAILS}-box-set`] || '',
                                NoOfTitles: filmValues[`${IMPORT_DETAILS}-no-of-titles-submission`] || '',
                                FilmTitleDetailsList: filmTitleDetailsList,
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                Rating: filmValues[`${TITLE_DETAILS}-rating-code`] || '',
                                DecisionCode: filmValues[`${TITLE_DETAILS}-decision-code`] || '',
                                ConsumerAdvice: filmValues[`${TITLE_DETAILS}-original-submission-consumer-advice`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                EpisodeNo: filmValues[`${EPISODE_DETAILS}-episode-no`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        case 'submissionOfFilmsWithPartyPoliticalContentDistribution':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                Producer: filmValues[`${TITLE_DETAILS}-producer`] || '',
                                ProductionYear: filmValues[`${TITLE_DETAILS}-year-production`] || '',
                                ProductionPlace: filmValues[`${TITLE_DETAILS}-place-production`] || '',
                                PlaceOfProductionOthers: filmValues[`${TITLE_DETAILS}-other-place-of-production`] || '',
                                MainFeatureRunTime: filmValues[`${TITLE_DETAILS}-main-feature-running-time`] || '',
                                ExtraFeatureRunTime: filmValues[`${TITLE_DETAILS}-bonus-feature-running-time`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                ScreeningFrom: dateAndTime.length > 0 ? dateAndTime[0].from : '',
                                ScreeningTo: dateAndTime.length > 0 ? dateAndTime[0].to : '',
                                ScreeningVenue: filmValues[`${TITLE_DETAILS}-screening-venue`] || '',
                                EpisodeNo: filmValues[`${EPISODE_DETAILS}-episode-no`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[]),
                                PoliticalInformation: {
                                    MadeByPoliticalParty: filmValues[`${INFORMATION_ON_FILM}-made`] || '',
                                    PoliticalPartyMadeName: filmValues[`${INFORMATION_ON_FILM}-made-political-name`] || '',
                                    SubmittedByPoliticalParty: filmValues[`${INFORMATION_ON_FILM}-submitted`] || '',
                                    PoliticalPartySubmitName: filmValues[`${INFORMATION_ON_FILM}-submitted-political-name`] || '',
                                    DeclarationList: [
                                        {
                                            pxSubscript: '1',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '1')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '2',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '2')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '3',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '3')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '4',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '4')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '5',
                                            pySelected: filmValues[`${INFORMATION_ON_FILM}-checklist`]
                                                .toString()
                                                .split(',')
                                                .find((i) => i === '5')
                                                ? 'true'
                                                : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        },
                                        {
                                            pxSubscript: '6',
                                            pySelected:
                                                filmValues[`${INFORMATION_ON_FILM}-i-have-exercised-editorial`] === 'Yes'
                                                    ? 'true'
                                                    : 'false',
                                            pxObjClass: 'IMDA-FVGCS-Data-FVG-Films'
                                        }
                                    ],
                                    Remarks: filmValues[`${INFORMATION_ON_FILM}-remarks`] || ''
                                }
                            };
                            break;
                        case 'submissionofTitlesToObtainAnIndicativeRatingDistribution':
                            return {
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                EpisodeNo: filmValues[`${EPISODE_DETAILS}-episode-no`] || '',
                                Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        case 'submissionOfCoClassifiedFilmsForExhibition':
                            return {
                                IsExistingTitle: existingTitle === 'same-as-mine' ? 'Yes' : existingTitle === 'new-title' ? 'No' : 'No',
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                PurposeOfSubmission: filmValues[`${TITLE_DETAILS}-submission-purpose`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                ScreeningFrom: dateAndTime.length > 0 ? dateAndTime[0].from : '',
                                ScreeningTo: dateAndTime.length > 0 ? dateAndTime[0].to : '',
                                ScreeningVenue: filmValues[`${TITLE_DETAILS}-screening-venue`] || '',
                                SubtitleOne: filmValues[`${SUBTITLES_DETAILS}-subtitle-1`] || '',
                                SubtitleTwo: filmValues[`${SUBTITLES_DETAILS}-subtitle-2`] || '',

                                Rating: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-rating`] || '',
                                AttachmentList: attachmentPayloadSetting(
                                    (filmValues[`${CA_CLASSIFICATION_DETAILS}-attachments`] || []) as Attachment[]
                                ),
                                DecisionCode: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-decision`] || '',
                                ConsumerAdvice: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-consumer-advice`] || '',
                                Remarks: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-comments-remarks`] || ''
                                // Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                // LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                // AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        case 'submissionOfCoClassifiedTrailersProductAdvertisementForExhibition':
                            return {
                                IsExistingTitle: 'No',
                                SubmissionType: filmValues[`${TRAILER_OR_PRODUCT_ADVERTISEMENT_DETAILS}-submission-type`] || '',
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                RunTime: filmValues[`${TITLE_DETAILS}-running-time`] || '',
                                PurposeOfSubmission: filmValues[`${TITLE_DETAILS}-submission-purpose`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                IsSubmissionExtraFeatures: filmValues[`${TITLE_DETAILS}-submission-extra-features`] || '',
                                IsExtraFeaturesClassified: filmValues[`${TITLE_DETAILS}-classify-extra-features`] || '',
                                ScreeningFrom: dateAndTime.length > 0 ? dateAndTime[0].from : '',
                                ScreeningTo: dateAndTime.length > 0 ? dateAndTime[0].to : '',
                                ScreeningVenue: filmValues[`${TITLE_DETAILS}-screening-venue`] || '',
                                SubtitleOne: filmValues[`${SUBTITLES_DETAILS}-subtitle-1`] || '',
                                SubtitleTwo: filmValues[`${SUBTITLES_DETAILS}-subtitle-2`] || '',

                                Rating: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-rating`] || '',
                                AttachmentList: attachmentPayloadSetting(
                                    (filmValues[`${CA_CLASSIFICATION_DETAILS}-attachments`] || []) as Attachment[]
                                ),
                                DecisionCode: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-decision`] || '',
                                ConsumerAdvice: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-consumer-advice`] || '',
                                Remarks: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-comments-remarks`] || ''
                                // Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                // LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                // AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        case 'submissionOfCoClassifiedFilmsForDistribution':
                            return {
                                IsExistingTitle: existingTitle === 'same-as-mine' ? 'Yes' : existingTitle === 'new-title' ? 'No' : 'No',
                                Format: filmValues[`${IMPORT_DETAILS}-format`] || '',
                                OnlineLink: filmValues[`${IMPORT_DETAILS}-online-link`] || '',
                                pyUserName: filmValues[`${IMPORT_DETAILS}-id-username`] || '',
                                PasswordValue: filmValues[`${IMPORT_DETAILS}-password`] || '',
                                PreferredDate: filmValues[`${IMPORT_DETAILS}-dateCombo-main`] || '',
                                PreferredTime: filmValues[`${IMPORT_DETAILS}-dateCombo-radio-day`] || 'AM',
                                // DCPReadyDate: filmValues[`${IMPORT_DETAILS}-dcp-ready-date`] || '',
                                IsKeyDeliveryMessageRequired: filmValues[`${IMPORT_DETAILS}-kdm-required`] || '',
                                OtherFormat: filmValues[`${IMPORT_DETAILS}-other-format`] || '',
                                NoOfPieces: filmValues[`${IMPORT_DETAILS}-no-of-pieces`] || '',
                                Type: filmValues[`${IMPORT_DETAILS}-type`] || '',
                                LanguageGroup: filmValues[`${TITLE_DETAILS}-language-group`] || '',
                                SubLanguage: filmValues[`${TITLE_DETAILS}-sub-language-group`] || '',
                                OtherLanguageDesc: filmValues[`${TITLE_DETAILS}-other-language-desc`] || '',
                                Title: filmValues[`${TITLE_DETAILS}-title`] || '',
                                RomanizedTitle: filmValues[`${TITLE_DETAILS}-romaised-title`] || '',
                                AlsoKnownAs: filmValues[`${TITLE_DETAILS}-also-known-as`] || '',
                                Director: filmValues[`${TITLE_DETAILS}-director`] || '',
                                MainFeatureRunTime: filmValues[`${TITLE_DETAILS}-main-feature-running-time`] || '',
                                ExtraFeatureRunTime: filmValues[`${TITLE_DETAILS}-bonus-feature-running-time`] || '',
                                EventNature: filmValues[`${TITLE_DETAILS}-nature-of-event-activity`] || '',
                                EpisodeNo: filmValues[`${EPISODE_DETAILS}-episode-no`] || '',
                                Rating: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-rating`] || '',
                                AttachmentList: attachmentPayloadSetting(
                                    (filmValues[`${CA_CLASSIFICATION_DETAILS}-attachments`] || []) as Attachment[]
                                ),
                                DecisionCode: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-decision`] || '',
                                ConsumerAdvice: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-consumer-advice`] || '',
                                Remarks: filmValues[`${CA_CLASSIFICATION_DETAILS}-ca-comments-remarks`] || ''
                                // Remarks: filmValues[`${REMARKS}-remarks`] || '',
                                // LinkToSupportingDocuments: filmValues[`${REMARKS}-link-to-attachments`],
                                // AttachmentList: attachmentPayloadSetting((filmValues[`${REMARKS}-attachments`] || []) as Attachment[])
                            };
                            break;
                        default:
                    }
                })
            }),
            ...(isCA && {
                Title: CADraftTitle,
                CAProfileUUID: CAProfileUUID,
                ...(!isCAUpdateProfile && {
                    QuestionListPage: [
                        {
                            Question: 'Q1',
                            AnswerPage: {
                                Answer: CARegistration[`${CONTENT_ASSESSOR_REGISTRATION}-question-1`] || '',
                                Remarks: CARegistration[`${CONTENT_ASSESSOR_REGISTRATION}-question-1-remarks`] || ''
                            }
                        },
                        {
                            Question: 'Q2',
                            AnswerPage: {
                                Answer: CARegistration[`${CONTENT_ASSESSOR_REGISTRATION}-question-2`] || '',
                                Remarks: CARegistration[`${CONTENT_ASSESSOR_REGISTRATION}-question-2-remarks`] || ''
                            }
                        },
                        {
                            Question: 'Q3',
                            AnswerPage: {
                                Answer: CARegistration[`${CONTENT_ASSESSOR_REGISTRATION}-question-3`] || '',
                                Remarks: CARegistration[`${CONTENT_ASSESSOR_REGISTRATION}-question-3-remarks`] || ''
                            }
                        }
                    ],
                    AttachmentPage: {
                        LinkToAttachments: CARegistration[`${CONTENT_ASSESSOR_REGISTRATION}-link-to-attachments`] || '',
                        AttachmentList: attachmentPayloadSetting(
                            (CARegistration[`${CONTENT_ASSESSOR_REGISTRATION}-attachments`] || []) as Attachment[]
                        )
                    }
                }),
                ...(isCAUpdateProfile && {
                    ProfileUpdate: {
                        QualificationDetails: {
                            Institution: AcademicQualification[`${ACADEMIC_QUALIFICATION}-name-of-institution`] || '',
                            CountryCode: AcademicQualification[`${ACADEMIC_QUALIFICATION}-country`] || '',
                            QualificationAttained: AcademicQualification[`${ACADEMIC_QUALIFICATION}-highest-qualification-attained`] || '',
                            Others: AcademicQualification[`${ACADEMIC_QUALIFICATION}-other-qualification-attainted`] || '',
                            CourseName: AcademicQualification[`${ACADEMIC_QUALIFICATION}-name-of-course`] || '',
                            Year: AcademicQualification[`${ACADEMIC_QUALIFICATION}-year-of-completion`] || '',
                            AttachmentPage: {
                                AttachmentList: attachmentPayloadSetting(
                                    (AcademicQualification[`${ACADEMIC_QUALIFICATION}-attachments`] || []) as Attachment[]
                                )
                            }
                        },
                        LanguageList: languageProficiency.map((i) => ({
                            Code: i.language,
                            Language: i['other-language'],
                            CanWrite: i.written === 'Yes' ? true : false,
                            CanSpeak: i.spoken === 'Yes' ? true : false
                        })),
                        EmploymentDetails: {
                            Name: EmploymentDetails[`${CURRENT_EMPLOYMENT_DETAILS}-name-of-employer`] || '',
                            Type: EmploymentDetails[`${CURRENT_EMPLOYMENT_DETAILS}-type-of-employment`] || '',
                            designation: EmploymentDetails[`${CURRENT_EMPLOYMENT_DETAILS}-current-designation`] || '',
                            StartDateOnly: EmploymentDetails[`${PERIOD_OF_EMPLOYMENT}-start-date`] || '',
                            AddressString: EmploymentDetails[`${ADDRESS_OF_EMPLOYER}-address`] || '',
                            CountryCode: EmploymentDetails[`${ADDRESS_OF_EMPLOYER}-country`] || '',
                            OfficeNumber:
                                '+' +
                                    EmploymentDetails[`${ADDRESS_OF_EMPLOYER}-office-no-country-code`] +
                                    EmploymentDetails[`${ADDRESS_OF_EMPLOYER}-office-no-main`].toString() || ''
                        }
                    }
                })
            })
        },
        ...(pageInstructions?.length > 0 && { pageInstructions })
    };
};

const emptySet = {
    [`${MOVIE_TRAILER_DETAILS}-submission-type`]: '',

    [`${IMPORT_DETAILS}-format`]: '',
    [`${IMPORT_DETAILS}-online-link`]: '',
    [`${IMPORT_DETAILS}-id-username`]: '',
    [`${IMPORT_DETAILS}-password`]: '',
    [`${IMPORT_DETAILS}-dateCombo-main`]: '',
    [`${IMPORT_DETAILS}-dateCombo-radio-day`]: 'AM',
    [`${IMPORT_DETAILS}-dcp-ready-date`]: '',
    [`${IMPORT_DETAILS}-kdm-required`]: '',
    [`${IMPORT_DETAILS}-other-format`]: '',
    [`${IMPORT_DETAILS}-no-of-pieces`]: '',
    [`${IMPORT_DETAILS}-type`]: '',
    [`${IMPORT_DETAILS}-box-set`]: '',
    [`${IMPORT_DETAILS}-no-of-titles-submission`]: '',

    [`${TITLE_DETAILS}-title`]: '',
    [`${TITLE_DETAILS}-romaised-title`]: '',
    [`${TITLE_DETAILS}-also-known-as`]: '',
    [`${TITLE_DETAILS}-director`]: '',
    [`${TITLE_DETAILS}-rating`]: '',
    [`${TITLE_DETAILS}-rating-code`]: '',
    [`${TITLE_DETAILS}-decision`]: '',
    [`${TITLE_DETAILS}-decision-code`]: '',
    [`${TITLE_DETAILS}-original-submission-consumer-advice`]: '',
    [`${TITLE_DETAILS}-footage`]: '',
    [`${TITLE_DETAILS}-place-production`]: '',
    [`${TITLE_DETAILS}-other-place-of-production`]: '',
    [`${TITLE_DETAILS}-year-production`]: '',
    [`${TITLE_DETAILS}-producer`]: '',

    [`${TITLE_DETAILS}-running-time`]: '',
    [`${TITLE_DETAILS}-submission-purpose`]: '',
    [`${TITLE_DETAILS}-nature-of-event-activity`]: '',
    [`${TITLE_DETAILS}-submission-extra-features`]: '',
    [`${TITLE_DETAILS}-classify-extra-features`]: '',
    [`${TITLE_DETAILS}-screening-date`]: [
        {
            to: '',
            from: ''
        }
    ],
    [`${TITLE_DETAILS}-screening-venue`]: '',
    [`${TITLE_DETAILS}-language-group`]: '',
    [`${TITLE_DETAILS}-sub-language-group`]: '',
    [`${TITLE_DETAILS}-other-language-desc`]: '',
    [`${TITLE_DETAILS}-main-feature-running-time`]: '',
    [`${TITLE_DETAILS}-bonus-feature-running-time`]: '',

    [`${SUBTITLES_DETAILS}-subtitle-1`]: '',
    [`${SUBTITLES_DETAILS}-subtitle-2`]: '',

    [`${INFORMATION_ON_FILM}-made`]: '',
    [`${INFORMATION_ON_FILM}-made-political-name`]: '',
    [`${INFORMATION_ON_FILM}-submitted`]: '',
    [`${INFORMATION_ON_FILM}-submitted-political-name`]: '',
    [`${INFORMATION_ON_FILM}-remarks`]: '',
    [`${INFORMATION_ON_FILM}-checklist`]: '',
    [`${INFORMATION_ON_FILM}-i-have-exercised-editorial`]: 'No',

    [`${REMARKS}-remarks`]: '',
    [`${REMARKS}-link-to-attachments`]: '',
    [`${REMARKS}-attachments`]: '',

    [`${EPISODE_DETAILS}-episode-no`]: ''
};

const filmsPayload = {
    formatRetrieve,
    autoFillData,
    formatSave,
    emptySet
};

export default filmsPayload;
